module.exports = __webpack_public_path__ + "media/src/images/server_down-532ea75dc935139db4aeeaeca0f2dd98.svg";